<template lang="pug">
  swiper.swiper(:options="swiperOption")
    swiper-slide
      div.comment
        div O {{SISTEMA}} tem sido uma ferramenta muito
                  |  importante para promoção da regularização fundiária no Estado,
                  |  a proximidade e facilidade de acesso a população foi o ponto chave
                  |  para se alcançar grandes resultados em tão pouco tempo. Acreditamos
                  |  que o {{SISTEMA}} é a nova chave para entregarmos um produto atual e com
                  |  seguranca jurídica e assim desenvolvermos um diálogo mais fácil não
                  |  só com o interessado, como também com outros órgãos regularizadores.
                  br
                  br
                  | Mariceli Moura
                  br
                  br
                  rate(:length="5" :value="5" :readonly="true")
    swiper-slide
      div.comment O {{SISTEMA}} se alinha às principais demandas de um mundo tecnológico.
                  |  Não só permite iniciar e analisar processos por meio de qualquer
                  |  dispositivo com acesso à internet, como sua interface auxilia na
                  |  compreensão dos passos a serem seguidos pelo interessado e pelo
                  |  servidor público. Além disso, cria uma possibilidade de interação
                  |  quase imediata, por meio de troca de mensagens. O {{SISTEMA}} tem a virtude
                  |  aproximar o cidadão do {{ORGAO}}.
                  br
                  br
                  | João Olegário
                  br
                  br
                  rate(:length="5" :value="5" :readonly="true")
    swiper-slide
      div.comment O {{SISTEMA}} é a resposta eficiente para o caminho de uma regularização
                  |  fundiária rápida e extremamente eficaz. Trazer o campo para a cidade
                  |  agora é muito fácil, antigamente precisávamos viajar do interior para
                  |  a capital e protocolar todos os documentos necessários para o pedido de
                  |  regularização fundiária, com a criação de um sistema moderno o futuro
                  |  chegou e agora em poucos cliques conseguimos carregar todos os dados e
                  |  acompanhar o andamento do processo em tempo real. O {{ORGAO}} mostra-se atual
                  |  e atuante em torno das demandas fundiárias e necessidades advindas daqueles
                  |  que trabalham no campo bem como dos que atuam nos processos administrativos.
                  br
                  br
                  | Alexandre Gouvêa
                  br
                  br
                  rate(:length="5" :value="5" :readonly="true")
    swiper-slide
      div.comment Só posso dizer o quanto estou feliz em acompanhar a evolução e melhoramento
                  |  dos serviços prestados pelo {{ORGAO}} à sociedade. A plataforma {{SISTEMA}} trouxe
                  |  inovação tecnológica e celeridade processual. O sistema é de fácil manuseio,
                  |  tanto para o protocolo de pedidos e recebimento de notificações. Essa interação
                  |  possibilita o acompanhamento diário dos processos independente da sua localização
                  |  física bastando ao advogado acesso a internet no módulo {{SISTEMA}} on-line.
                  br
                  br
                  | Naire Rei
                  br
                  br
                  rate(:length="5" :value="5" :readonly="true")
    div.swiper-button-prev(slot="button-prev")
    div.swiper-button-next(slot="button-next")
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { mapState } from 'vuex'

export default {
  name: 'swiper-example-navigation',
  title: 'Navigation',

  components: {
    Swiper,
    SwiperSlide
  },

  data () {
    return {
      rating: 5,
      swiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },

  computed: {
    ...mapState({
      ORGAO: state => state.userInterface.dadosEstado.ORGAO,
      SISTEMA: state => state.userInterface.dadosEstado.SISTEMA
    })
  }
}
</script>

<style lang="scss" scoped>
.comment {
  padding: 20px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  height: 30%;
  background: white;
  width: 10%;
  font-size: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: unset;
}
.swiper {
  height: 578px;
  width: 100%;
  background: #f9f5fa 0% 0% no-repeat padding-box;

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 10px;
    width: 100%;
  }
}

@media screen and (max-width: 320px) {
  .comment {
    font-size: 13px;
    width: 90%;
    height: auto;
  }
}

@media screen and (min-width: 321px) {
  .comment {
    font-size: 15px;
    width: 98%;
    height: 70%;
  }
}

@media screen and (min-width: 425px) {
  .comment {
    font-size: 17px;
    width: 90%;
    height: 50%;
  }
}

@media screen and (min-width: 768px) {
  .comment {
    font-size: 18px;
  }
}

@media screen and (min-width: 1024px) {
  .comment {
    font-size: 20px;
    height: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/home/TheComments.vue